document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelectorAll('.banner-frontpage.banner-frontpage--yellow').length) {
    document.querySelectorAll('button.uiButton').forEach(element => {
      element.classList.add('bg-blue-light')
    })
  }
})
